import React, { FC, MouseEventHandler } from 'react';
import { ButtonLoader } from '../../ButtonLoader';

interface Props {
    title?: string;
    styles?: string;
    type?: 'button' | 'submit' | 'reset';
    children?: any;
    disabled?: boolean;
    onClick?: MouseEventHandler;
    buttonLoader?: boolean;
}

const OiButton: FC<Props> = props => {
    const { styles, type, children, disabled, onClick, buttonLoader, title } = props;

    return (
        <React.Fragment>
            <button disabled={buttonLoader ? true : disabled ? true : false} className={styles} type={type} onClick={onClick}>
                {buttonLoader ? <ButtonLoader /> : children || title}
            </button>
        </React.Fragment>
    );
};

export default OiButton;
